<template>
  <div>
    <div id="pdf-view">
      <div v-for="(pageData, pageIndex) in pdf.data" :class="['page', pageIndex]" :key="pageIndex">
        <div class="header-box" v-if="pageIndex === 'page1'">
          <div class="row margin-B-l">
            <div class="small-7 column">
              <div class="img-box">
                <img :src="profileData.logo" />
              </div>
              <div class="billing-address">
                <div class="attn">Attn: Accounts Payable</div>
                <div class="corporate-name">{{ profileData.name }}</div>
                <div class="address">{{ addressLine.line1 }}</div>
                <div class="address">{{ addressLine.line2 }}</div>
              </div>
            </div>
            <div class="small-5 column">
              <div class="sales-label">INVOICE</div>
              <div class="invoice-info">
                <div>
                  <b>Invoice Number:</b>
                  <span>INV-{{ invoiceNumber }}</span>
                </div>
                <div>
                  <b>Invoice Date:</b>
                  <span>{{ today }}</span>
                </div>
                <div>
                  <b>Payment Due Date:</b>
                  <span>{{ invoiceData.dueDate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-period" v-if="pageIndex === 'page1'">
          <b>Invoice Period:</b>
          <span>{{ invoiceData.dateFrom }} - {{ invoiceData.dateTo }}</span>
        </div>
        <table>
          <thead>
            <th class="date">Completion Date</th>
            <th class="passenger">Passenger Name</th>
            <th class="rsvp-id">RSVP ID</th>
            <th class="location">Pickup/Dropoff</th>
            <th class="net-amount">Amount</th>
          </thead>
          <tbody>
            <tr v-for="(data, index) in pageData" :key="index">
              <td class="date">{{ data.completedDate }}</td>
              <td class="passenger">{{ data.passenger }}</td>
              <td class="rsvp-id">{{ data.id }}</td>
              <td class="location">
                {{ data.pickup }} - <br/>
                {{ data.dropoff }}
              </td>
              <td class="net-amount">${{ data.total }}</td>
            </tr>
          </tbody>
        </table>

        <div class="total-box records" v-if="pageIndex.substr(4) == totalPage">
          <label>Total Rercords:</label>
          <span>{{totalRecords}}</span>
        </div>
        <div class="total-box" v-if="pageIndex.substr(4) == totalPage">
          <label>Total Amount:</label>
          <span>${{total}}</span>
        </div>

        <div class="footer-box">Page {{ pageIndex.substr(4) }} of {{ totalPage }}</div>

      </div>
    </div>

    <div :class="{'modal':true, 'show':showWaitModal}">
      <div class="bg-overlay" @click="showWaitModal = false"></div>
      <div class="modal-content wait-modal">
        <div>
          Corporate Invoices can only be downloaded once.<br />
          Please keep the PDF file safe. Otherwise, <br />
          you will need to generate a new invoice.
        </div>

        <button class="button cta block small" @click="showWaitModal = false">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import ApiCorporate from '@/modules/api/corporate/profile'
const request = require('browser-request')

export default {
  name: 'invoice-pdf',
  data () {
    return {
      pdf: {
        data: {}
      },
      today: moment().format('MM/DD/YYYY'),
      invoiceNumber: '',
      totalRecords: 0,
      total: 0, // total amount
      totalPage: 0,
      pdfProccess: '',
      showWaitModal: false
    }
  },
  computed: {
    corporateId () { return this.$route.params.id },
    profileStore () { return this.$store.state.corporate.profile },
    profileData () { return this.profileStore.info },
    invoiceData () { return this.$store.state.corporate.invoice },
    addressLine () {
      let line1 = this.profileData.billingAddress1
      if (this.profileData.billingAddress2) {
        line1 = this.profileData.billingAddress2 + ' ' + line1
      }

      return {
        line1: line1,
        line2: this.profileData.billingCity + ' ' + this.profileData.billingZip
      }
    },
    loading () { return this.$store.state.corporate.invoice.loading }
  },
  methods: {
    buildTable () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('corporate/setInvoiceFormLoading', true)
      self.pdf.data = {}
      ApiCorporate.getAllTransactions(self, self.$route.params.id, res => {
        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('corporate/setInvoiceFormLoading', false)
            self.$emit('zeroResults')
            return
          }

          let i = 1
          self.total = 0

          // delete later - start
          // if (res.list.length < 1000) {
          //   let addRow = 1000 - res.list.length
          //   for (let z = 0; z < addRow; z++) {
          //     res.list.push(res.list[0])
          //   }
          // }
          // delete later - end

          self.totalRecords = res.list.length
          res.list.forEach(rsvp => {
            if (!self.pdf.data['page' + i]) {
              self.pdf.data['page' + i] = []
            }

            let pickup = `${rsvp.pickupLocation.addressLine1}, ${rsvp.pickupLocation.city}, ${rsvp.pickupLocation.state}`
            let dropoff = `${rsvp.dropoffLocation.addressLine1}, ${rsvp.dropoffLocation.city}, ${rsvp.dropoffLocation.state}`
            let total = parseFloat(rsvp.breakdown.fare + rsvp.breakdown.pickupFee + rsvp.breakdown.tip + rsvp.breakdown.airportFee + rsvp.breakdown.travelInsurance)
            total -= rsvp.credits
            self.pdf.data['page' + i].push({
              id: rsvp.ID,
              completedDate: moment(rsvp.complete, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              passenger: rsvp.guest.firstName + ' ' + rsvp.guest.lastName,
              pickup: pickup,
              dropoff: dropoff,
              total: total.toFixed(2)
            })

            self.total += total || 0

            if (self.pdf.data['page' + i].length >= 25 ||
              (i === 1 && self.pdf.data['page1'].length >= 10)
            ) {
              i++
            }
          })

          self.$nextTick().then(() => {
            self.$forceUpdate()

            self.total = self.total.toFixed(2)
            self.totalPage = Object.keys(self.pdf.data).length
            setTimeout(() => {
              self.processPdf('pdf', i)
            }, 400)
          })
        } else {
          self.$store.commit('corporate/setInvoiceFormLoading', false)
        }
      })
    },
    processPdf (type, page) {
      let self = this
      // let start = moment(self.from)
      // let end = moment(self.to)
      let pageAsyncs  = []
      // let landscapeReports = self.orientation
      // let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let orientation ='p'
      self.pdfProccess = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })
      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      self.invoiceNumber = moment().format('X')

      setTimeout(() => {
        for (let i = 0; i < page; i++) {
          // self.pdf.current = 'page' + (i + 1)

          pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: '1'
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/jpeg', 0.9)
            self.pdfProccess.addImage(imgData, 'JPEG', 0, 0)
            if (i + 1 !== page) { self.pdfProccess.addPage() }
          }).catch(e => {
            document.body.style.overflow = 'auto'
            self.$store.commit('corporate/setInvoiceFormLoading', false)
            console.warn(e)
          }))
        }
        Promise.all(pageAsyncs).then(() => {
          // request.post({
          //   url: CONFIG.mediaHost + '/api/upload/uri',
          //   body: pdf.output('datauri')
          // }, function (err, res, body) {
          //   let _res = JSON.parse(body)
          //   if (_res.success) {
          //     self.createInvoice(_res.data.url)
          //   } else {
          //     self.$store.commit('corporate/setInvoiceFormLoading', false)
          //   }
          // })

          // pdf.save('invoice.pdf')
          self.createInvoice('https://prod-opoli-app.s3-us-west-2.amazonaws.com/web/invoice_notice.jpg')
        })
      }, 500)
    },
    createInvoice (pdfUrl) {
      let self = this

      let invoiceDate = self.$store.state.corporate.invoice
      self.$sdk.post('/admin/corporateprofile/' + self.corporateId + '/invoices', {
        token: self.$store.state.session.sessionToken,
        fileUrl: pdfUrl,
        startDate: moment(invoiceDate.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        endDate: moment(invoiceDate.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        dueDate: moment(invoiceDate.dueDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        status: 'unpaid'
      }, res => {
        if (!res.error) {
          self.pdfProccess.save('invoice.pdf')
          self.showWaitModal = true
        }
        self.$store.commit('corporate/setInvoiceFormLoading', false)
        self.$emit('refresh', res)
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
#pdf-view{
  position: fixed;
  top: 0%;
  right: 100%;
  // left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;
  z-index: -1;
  // z-index: 4;

  .page{
    padding: 30px;
    position: relative;
    width: 100%;
    height: 100%;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }

  .header-box{
    margin-bottom: 50px;
    .img-box{
      height: 100px;
      overflow: hidden;
      margin: 0 0 10px 15px;

      img{
        width: 100px;
        max-height: 100px;
      }
    }
    .sales-label{
      font-size: 36px;
      font-weight: 600;
      margin-top: 20px;
      color: #444;
      text-align: center;
    }
    .right-info{
      font-size: 12px;
      line-height: 1.3;
    }
    .billing-address, .invoice-info{
      font-size: 15px;
      line-height: 1.5;

      .attn{
        font-size: 12px;
        line-height: 1;
        color: #999;
      }
      .corporate-name{
        font-size: 21px;
        font-weight: 600;
      }
      .address{
        line-height: 1.3;
        font-size: 13px;
        color: #777;
      }
    }
    .invoice-info{
      div{ display: flex; }
      b, span{ display: inline-block; }
      b{
        color: #333;
        width: 170px;
        text-align: right;
        padding-right: 10px;
      }
      span{ color: #444; }
    }
  }

  .invoice-period{
    font-size: 14px;
    margin-bottom: 5px;
  }

  table{
    width: 100%;
    border-collapse: collapse;

    thead{
      font-weight: 600;
      color: #333;
      border: 1px solid rgba(0,0,0,0.3);
      background-color: #f3f3f3;
      th{
        font-size: 13px;
        padding: 4px;
      }
    }
    tbody{
      tr{
        background-color: #fff;
        border: 1px solid rgba(0,0,0,0.3);
        font-size: 13px;
        &:nth-child(even) { background: #f6f6f6; }
      }
      td{ padding: 4px; }
    }

    .date, .location, .passenger{ text-align: left; }
    .rsvp-id{ text-align: center; }
    .location{ line-height: 1.1; }
    .net-amount{
      text-align: center;
      width: 120px;
    }
  }
}

.total-box{
  text-align: right;
  padding: 10px 0 0;
  font-size: 18px;
  line-height: 1;

  &.records{ margin-top: 10px; }
  label{
    color: #555;
  }
  span{
    font-weight: 600;
    display: inline-block;
    width: 120px;
    text-align: right;
  }
}

.footer-box{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  font-size: 13px;
  text-align: right;
  padding: 0 40px 20px 0;
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .modal-content{
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 15px 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    transform: translate(-50%, -50%);
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

    &.upload{
      top: 50%;
      width: 900px;
      height: 550px;
      margin-top: -265px;
      margin-left: -450px;

    }
  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
}

.wait-modal{
  text-align: center;

  div{
    padding: 40px 0;
  }
}

.margin-B-m{ margin-bottom: 10px; }
.margin-T-m{ margin-top: 10px; }
.margin-B-l{ margin-bottom: 20px; }
.margin-T-l{ margin-top: 20px; }
</style>


// WEBPACK FOOTER //
// src/components/Corporate/InvoicePDF.vue